import React from 'react';

export default function OrderTracking({
  trackForm,
  onTrackFormChange,
  onTrack,
  onHistory,
  isTrackingOrder,
  isLoadingHistory,
  trackError,
  trackResult,
  historyResults,
}) {
  return (
    <div className="mt-6 border-t pt-4 space-y-2">
      <h4 className="font-semibold">Track Order</h4>
      <input
        className="border w-full p-2 text-sm"
        placeholder="Order ID"
        value={trackForm.orderId}
        onChange={(e) => onTrackFormChange((c) => ({ ...c, orderId: e.target.value }))}
        aria-label="Order ID"
      />
      <input
        className="border w-full p-2 text-sm"
        placeholder="Phone Number"
        value={trackForm.phone}
        onChange={(e) => onTrackFormChange((c) => ({ ...c, phone: e.target.value }))}
        aria-label="Phone number for tracking"
      />
      <button
        onClick={onTrack}
        disabled={isTrackingOrder}
        className="w-full bg-gray-800 text-white py-2 rounded text-sm disabled:opacity-60"
      >
        {isTrackingOrder ? 'Checking...' : 'Track'}
      </button>
      <button
        onClick={onHistory}
        disabled={isLoadingHistory}
        className="w-full bg-gray-600 text-white py-2 rounded text-sm disabled:opacity-60"
      >
        {isLoadingHistory ? 'Loading...' : 'History by Phone'}
      </button>
      {trackError ? <p className="text-sm text-red-600">{trackError}</p> : null}
      {trackResult ? (
        <div className="text-sm bg-gray-50 border rounded p-2">
          <p>
            <span className="font-medium">Status:</span> {trackResult.status}
          </p>
          <p>
            <span className="font-medium">Payment:</span> {trackResult.paymentMethod} / {trackResult.paymentStatus}
          </p>
          <p>
            <span className="font-medium">Total:</span> P{Number(trackResult.totalAmount || 0).toFixed(2)}
          </p>
        </div>
      ) : null}
      {historyResults.length > 0 ? (
        <div className="text-sm bg-gray-50 border rounded p-2 space-y-2">
          <p className="font-medium">Order History</p>
          {historyResults.map((order) => (
            <div key={order._id} className="border rounded p-2 bg-white">
              <p>Order: {order._id}</p>
              <p>Status: {order.status}</p>
              <p>Payment: {order.paymentMethod} / {order.paymentStatus}</p>
              <p>Total: P{Number(order.totalAmount || 0).toFixed(2)}</p>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
